export default "/images/70036bc170d6b2801c4c48e8bb2886bf.png";